
import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { MockTestCard } from './MockTestCard';
import { ArrowLeftIcon } from './icons/InterfaceIcons';

export const JEEMainMockTestView = ({ exam, onBack, onStartTest }) => {
    const [tests, setTests] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchJeeMainTests = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const { data, error: dbError } = await supabase
                    .from('exams')
                    .select('*')
                    .ilike('exam', '%MOCK%');

                if (dbError) throw dbError;

                const formattedTests = data.map(test => ({
                    id: test.id,
                    name: test.Name,
                    duration: test.Duration,
                    questions: test.Questions.split(',').length,
                    type: 'Full Syllabus',
                    difficulty: 'Medium',
                    tags: test.Tags ? test.Tags.split(',').map(t => t.trim()) : ['New'],
                    attempts: 0,
                }));

                setTests(formattedTests);
            } catch (err) {
                console.error('Error fetching JEE Main mock tests:', err);
                setError('Failed to load mock tests. Please check back later.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchJeeMainTests();
    }, []);

    if (isLoading) {
        return (
            <div className="flex-1 flex items-center justify-center min-h-[calc(100vh-250px)]">
               <div className="flex flex-col items-center">
                 <div className="w-12 h-12 border-4 border-brand-primary border-t-transparent rounded-full animate-spin"></div>
                 <p className="mt-4 text-brand-text-secondary">Loading JEE Main Mock Tests...</p>
               </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border border-red-200">
                <h3 className="text-lg font-semibold text-brand-accent-red">An Error Occurred</h3>
                <p className="text-brand-text-secondary mt-1">{error}</p>
            </div>
        );
    }

    return (
        <div className="animate-fade-in space-y-8">
            <div className="flex items-center justify-between">
                <button onClick={onBack} className="flex items-center space-x-2 text-sm font-semibold text-brand-text-secondary hover:text-brand-primary transition-colors">
                    <ArrowLeftIcon className="w-5 h-5" />
                    <span>Back to Dashboard</span>
                </button>
                <p className="text-sm text-brand-text-secondary">Home &gt; {exam.name} &gt; <span className="font-semibold text-brand-text-primary">Mock Tests</span></p>
            </div>

            <header className="bg-brand-surface border border-brand-border rounded-xl p-6 space-y-4">
                <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-brand-text-primary">{exam.name} Mock Tests</h1>
                <p className="text-brand-text-secondary">Full syllabus & sectional mocks to sharpen your edge.</p>
            </header>

            {tests.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                    {tests.map(test => <MockTestCard key={test.id} test={test} onStartTest={onStartTest} />)}
                </div>
            ) : (
                <div className="text-center py-16 bg-brand-surface rounded-lg border border-brand-border">
                    <h3 className="text-lg font-semibold text-brand-text-primary">No Mock Tests Available</h3>
                    <p className="text-brand-text-secondary mt-1">
                        We are working on adding new tests. Please check back soon.
                    </p>
                </div>
            )}
        </div>
        // <div>Feature Coming Soon !!</div>

    );
};
